import { Controller } from "@hotwired/stimulus"

// Página /custom_notifications: sincroniza contador, empty state y acciones
// del header cuando una fila se borra por swipe (evento swipe-row:deleted).
// El total viene del server (cuenta todas las páginas, no solo las visibles)
// — doc: _docs/features/notifications/account_notifications.md

export default class extends Controller {
  static targets = ["list", "count", "emptyTemplate", "loadMore", "markAll"]
  static values = { markAllUrl: String }

  // Optimista, como en partner: los dots se apagan ya y si el POST falla el
  // estado real se corrige en el próximo render server-side
  markAllRead() {
    this.element.querySelectorAll(".notif-row.is-unread").forEach((row) => {
      row.classList.remove("is-unread")
    })

    fetch(this.markAllUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content }
    }).catch((error) => console.error("No se pudo marcar todo como leído:", error))
  }

  rowDeleted(event) {
    const total = event.detail.total
    if (total === null || total === undefined) return

    if (total <= 0) {
      this.#showEmptyState()
    } else if (this.hasCountTarget) {
      this.countTarget.textContent = `${total} ${total === 1 ? "notificación" : "notificaciones"}`
    }
  }

  #showEmptyState() {
    if (this.hasCountTarget) this.countTarget.remove()
    if (this.hasMarkAllTarget) this.markAllTarget.remove()
    if (this.hasLoadMoreTarget) this.loadMoreTarget.remove()
    if (this.hasListTarget && this.hasEmptyTemplateTarget) {
      // La fila que disparó el evento aún vive en el DOM (el remove corre
      // después del dispatch): vaciar la lista la limpia junto con el resto
      this.listTarget.innerHTML = ""
      const empty = this.emptyTemplateTarget.content.firstElementChild
      if (empty && !document.getElementById("no-notifications-message")) {
        this.listTarget.insertAdjacentElement("afterend", empty.cloneNode(true))
      }
    }
  }
}
